var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "search-result" }, [
    _c(
      "div",
      {
        staticClass: "search-result__column",
        attrs: { "data-column": "title", "data-title": "Title" },
      },
      [
        _c("router-link", { staticClass: "company", attrs: { to: _vm.link } }, [
          _vm.resource.creator.avatar
            ? _c("img", {
                staticClass: "avatar avatar--small",
                attrs: {
                  src: `/images/avatar/${_vm.resource.creator.id}`,
                  title: _vm.resource.creator.name,
                  alt: `${_vm.resource.creator.name}'s avatar`,
                  width: "32",
                  height: "32",
                },
              })
            : _c("img", {
                staticClass: "avatar avatar--small",
                attrs: {
                  src: "//placehold.it/32x32",
                  width: "32",
                  height: "32",
                  alt: "",
                },
              }),
          _vm._v(" "),
          _c("span", {
            staticClass: "name",
            domProps: { innerHTML: _vm._s(_vm.resource.name) },
          }),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "search-result__column",
        attrs: { "data-column": "category", "data-title": "Category" },
      },
      [_c("span", { domProps: { textContent: _vm._s(_vm.resource.category) } })]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "search-result__column",
        attrs: { "data-column": "sector", "data-title": "Sector" },
      },
      [
        _vm.sector
          ? _c("span", { staticClass: "sector" }, [
              _vm._v(_vm._s(_vm.sector.name)),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "search-result__column",
        attrs: { "data-column": "created", "data-title": "Created" },
      },
      [_c("span", { domProps: { innerHTML: _vm._s(_vm.resource.created_at) } })]
    ),
    _vm._v(" "),
    _vm.resource.found_highlights
      ? _c(
          "div",
          {
            staticClass: "search-result__column",
            attrs: { "data-column": "highlights" },
          },
          _vm._l(_vm.resource.found_highlights, function (highlight) {
            return _c("HighlightResult", {
              key: highlight.key,
              attrs: { resource: highlight },
            })
          }),
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.resource.attachment_highlights &&
    _vm.resource.attachment_highlights.length > 0
      ? _c(
          "div",
          {
            staticClass: "search-result__column",
            attrs: { "data-column": "documents" },
          },
          [
            _c("div", { staticClass: "highlighted-result" }, [
              _c("span", { staticClass: "highlighted-result__title" }, [
                _vm._v("AI Overview"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "highlighted-result__content" }, [
                _c(
                  "ul",
                  { staticClass: "ai-docs" },
                  _vm._l(
                    _vm.resource.attachment_highlights,
                    function (attachment_highlight) {
                      return _c(
                        "li",
                        [
                          _c("AIOverview", {
                            attrs: { resource: attachment_highlight },
                          }),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }